<div class="nova-font-style">
  <div class="top-margin-15"></div>
  <div *ngIf="!outerLoading">
    <div *ngIf="showContactUserComponent; else user">
      <app-manage-users-and-contact></app-manage-users-and-contact>
    </div>
    <ng-template #user>
      <h2>Users</h2>
      <div class="row">
        <div class="col s12 m12 l12 xl12">
          <kendo-grid [data]="gridData" (add)="userHandler($event)" (edit)="userHandler($event)"
            (remove)="openDeleteDialog($event)">
            <ng-template kendoGridToolbarTemplate>
              <div class="row bottom-margin-0">
                <div class="col l6 xl6 margin-5">
                  <button kendoGridAddCommand *ngIf="operators.Add" class="btn btn-fullwidth background-red"
                    id="profile_add_Btn">
                    <span class="k-icon k-i-plus height-auto"></span>Add User
                  </button>
                  <p id="profile-mobile-view-msg" class="text-red"><span class="k-icon k-i-warning"></span>Modifying
                    user
                    is
                    not available on Mobile Devices</p>
                </div>
              </div>
            </ng-template>

            <kendo-grid-command-column media="(min-width: 901px)" title="" width="90"
              *ngIf="operators.Add || operators.Delete">
              <ng-template kendoGridCellTemplate let-isNew="isNewUser" let-dataItem>
                <div class="align-center">
                  <a kendoGridEditCommand id="editInnerRow">
                    <span class="k-icon k-i-edit link-icon"></span>
                  </a>
                  <a kendoGridRemoveCommand id="removeInnerRow">
                    <span class="k-icon k-i-delete link-icon"></span>
                  </a>
                </div>
              </ng-template>
            </kendo-grid-command-column>

            <!-- Mobile View -->
            <kendo-grid-column media="(max-width: 900.98px)" title="User Information">
              <ng-template kendoGridCellTemplate let-dataItem>
                <dl>
                  <dd>
                    <div><span class="bold">Name:</span>
                      {{ dataItem.fullName }}
                    </div>
                  </dd>

                  <dd class="phone-number">
                    <div><span class="bold">Phone:</span>
                      {{ dataItem.phoneNumber | phone }}
                    </div>
                    <div *ngIf="dataItem.phoneNumberExtension"><span class="bold phone-ext">Ext:</span>
                      {{ dataItem.phoneNumberExtension }}
                    </div>
                  </dd>

                  <dd>
                    <div><span class="bold">Email Address:</span>
                      {{ dataItem.emailAddress }}
                    </div>
                  </dd>

                  <dd>
                    <div><span class="bold">Roles:</span>
                      {{ dataItem.roles }}
                    </div>
                  </dd>
                </dl>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column media="(min-width: 901px)" field="firstName" title="First Name" width="140">
            </kendo-grid-column>
            <kendo-grid-column media="(min-width: 901px)" field="lastName" title="Last Name" width="140">
            </kendo-grid-column>
            <kendo-grid-column media="(min-width: 901px)" field="middleName" title="MI" width="50"
              [headerClass]="{'align-center': true}">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div class="align-center">
                  <span>
                    {{dataItem.middleName}}
                  </span>
                </div>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column media="(min-width: 901px)" field="title" title="Title" width="80">
            </kendo-grid-column>
            <kendo-grid-column media="(min-width: 901px)" field="phoneNumber" title="Phone 1" width="125">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.phoneNumber | phone}}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column media="(min-width: 901px)" field="phoneNumberExtension" title="Ext 1" width="65">
            </kendo-grid-column>
            <kendo-grid-column media="(min-width: 901px)" field="emailAddress" title="Email Address" width="220">
            </kendo-grid-column>
            <kendo-grid-column media="(min-width: 901px)" field="roles" title="Roles" width="280">
            </kendo-grid-column>
          </kendo-grid>
        </div>
        <div class="scroll-text text-red" *ngIf="gridData">
          <span [innerHTML]="scrollMessage"></span>
        </div>
      </div>

      <app-add-edit-users *ngIf="operators.Add || operators.Edit" [userInfo]="userInfo"
        (responseMsg)="displayResult($event)"></app-add-edit-users>

      <!-- DELETE DIALOG -->
      <kendo-dialog title="Delete User" class="app-dialog" *ngIf="isDeleteOpened" (close)="isDeleteOpened = false"
        [minWidth]="450" id="delete-user-dialog">
        <p class="dialog-heading margin-30 align-center" id="delete-user-msg">{{deleteUserMsg}} <strong
            class="bold">{{selectedDataItem.fullName}}</strong>?</p>
        <div *ngIf="displayload">
          <div class="stroke-separator-margin-5"></div>
          <span class="k-i-loading k-icon col-md-offset-5 kload-page"></span>
          <span class="dotLoading left-padding-5">Deleting</span>
        </div>
        <kendo-dialog-actions>
          <button kendoButton class="k-button" id="delete-no-btn" [disabled]="displayload"
            (click)="isDeleteOpened = false">No</button>
          <button kendoButton class="k-button" id="delete-yes-btn" [disabled]="displayload" (click)="close('yes')"
            primary="true">Yes</button>
        </kendo-dialog-actions>
      </kendo-dialog>
      <app-notification-loading></app-notification-loading>
    </ng-template>
  </div>
</div>
